import React, { useRef } from "react"
import { MdClose, MdSearch } from "react-icons/md"
import FieldLoader from "./FieldLoader"

const InlineTextField = ({ label, placeholder, injectClass = "", loading, value, setValue, onEnter, ml, length, focus, blur, autoFocus = false, onClose }) => {
    const inputElem = useRef(null)

    const chgValue = (e) => {
        if (typeof setValue === 'function') setValue(e.target.value)
    }

    const focusInput = () => inputElem.current?.focus()

    const keyPress = (e) => {
        if (e.key === 'Enter' && onEnter !== undefined) onEnter()
    }

    const onFocus = (e) => {
        if (typeof focus === 'function') focus(e.target.value)
    }

    const onBlur = (e) => {
        if (typeof blur === 'function') blur(e.target.value)
    }

    const close = () => {
        if (typeof onClose === 'function') onClose()
    }

    const closeFunction = () => {
        setValue('')
        close()
    }

    return (
        <div
            className={`relative flex min-h-[46px] items-center gap-3 rounded-2xl border border-borderColor bg-white/90 px-4 py-2 shadow-soft transition focus-within:border-primeColor/50 ${loading ? "cursor-wait" : "cursor-text"} ${injectClass}`}
            onClick={focusInput}
        >
            <MdSearch className="text-xl text-tpColor" />
            {label ? <span className="hidden whitespace-nowrap text-sm font-semibold text-tpColor md:inline">{label}</span> : null}
            <div className="w-full">
                <input
                    disabled={loading}
                    autoFocus={autoFocus}
                    ref={inputElem}
                    className={`w-full bg-transparent px-0 py-1 text-sm font-medium text-tColor outline-none placeholder:text-tpColor/60 ${loading ? "cursor-wait" : ""}`}
                    type="text"
                    value={value}
                    onChange={chgValue}
                    onBlur={onBlur}
                    onFocus={onFocus}
                    onKeyPress={keyPress}
                    maxLength={ml ? `${length}` : ""}
                    placeholder={placeholder || (label ? `Search ${label.toLowerCase()}` : "Search")}
                />
            </div>
            {value !== null && value !== '' && (
                <button type="button" className="text-lg text-tpColor transition hover:text-tColor" onClick={closeFunction}>
                    <MdClose />
                </button>
            )}
            {loading && <FieldLoader injectClass="absolute bottom-0 left-2 w-[96%]" />}
        </div>
    )
}

export default InlineTextField
